import { Component, OnInit } from '@angular/core';
import { Param } from '../param';
import { MembershipPaymentService } from '../services/membership-payment.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

declare var App;

@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.scss']
})
export class SubscriptionsComponent implements OnInit {

  constructor(private m_pService: MembershipPaymentService,private dialog: MatDialog) { 
      this.m_pService.updateUserTimeZone({time_zone: new Date().getTimezoneOffset()}).subscribe(response => {
      console.log("timeZone Set")
    });
  }

  public subscriptions = {
    active_list: [],
    inactive_list: []
  };
  public confirmDialog: boolean = false;
  private param: Param = {
		page: 0,
		perPage: 25,
		sort: 'desc',
		search: '',
  }
  public family_list = [];
  public userDetails = App.user_details;
  public selected = [];

  ngOnInit() {
    // console.log(App);
    // this.subscriptions.list = [{
    //   id: 1, service_type: 'Telemedicine', subscription_plan: 'Yearly', start_date: '11 JUN 2020', end_date: '11 JUN 2021', download: 'link'
    // }];

    this.getSubscriptions();
    this.getInactiveSubscriptions();
  }

  onSelect({ selected }) {
		this.selected.splice(0, this.selected.length);
		this.selected.push(...selected);
  }

  getSubscriptions(){
    this.m_pService.getSubscriptionsApi({userId: App.user_details.id}).subscribe(response => {
			if (response.result.success) {
        this.subscriptions.active_list = response.result.data.active_plans;
        this.family_list = response.result.data.family_members;
this.family_list = this.family_list.map(function(item) {
  return item['first_name']+' '+ item['last_name'];
});        
      }
    });
  }

  getInactiveSubscriptions(){
    this.m_pService.getUserInActiveSubscriptions({userId: App.user_details.id}).subscribe(response => {
      if (response.result.success) {
        // this.subscriptions.active_list = response.result.data.active_plans;
        this.subscriptions.inactive_list = response.result.data.inactive_plans;
      }
    });
  }  
  
  cancelSubscription(rowData) {
    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {
        dialog:true,
        title: 'Confirm Subscription Cancellation',
        message: 'Are you sure, you want to cancel this subscription: '
      }
    });
    confirmDialog.afterClosed().subscribe(result => {
      if (result === true) {
        console.log(rowData)
        this.m_pService.cancelSubscriptionsApi({id: rowData.id}).subscribe(response => {
          if (response.result.success) {
            if(response.result.data.refund_amount > 0) {
              this.dialog.open(ConfirmDialogComponent, {
                  data: {
                    dialog: false,
                    title: 'Your Plan has been Cancelled!',
                    message: 'A refund of $'+response.result.data.refund_amount+' can take 5 - 7 Business days to process.'
                  }
                });
            }else{
              this.dialog.open(ConfirmDialogComponent, {
                  data: {
                    dialog: false,
                    title: 'Your Plan has been Cancelled!',
                    message: ''
                  }
                });
            }
            this.getSubscriptions();
            this.getInactiveSubscriptions();
          }
        });
      }
    });
  }  

}
